import { render, staticRenderFns } from "./fdInventory10.vue?vue&type=template&id=b645a23e"
import script from "./fdInventory10.vue?vue&type=script&lang=js"
export * from "./fdInventory10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports